import { Navigate } from 'react-router-dom';

import { EmptyState, Icon } from '@/components/ui';
import { useAuth } from '@/hooks/useAuth';
import { paths } from '@/routes/paths';

/**
 * Keeps every student and company page closed until the email is confirmed.
 *
 * The person themselves is sent to the code page, however they got here — the
 * logo, the Dashboard button, a typed address. An admin signed in as them stays
 * put and is told why the pages are locked, since the code is not theirs to
 * enter. `children` render once verified.
 */
export function VerifyEmailGate({ children }) {
  const { user, isImpersonating } = useAuth();
  if (!user || user.is_email_verified) return children;

  if (isImpersonating) {
    return (
      <EmptyState
        icon={<Icon name="alert" size={22} />}
        title={`${user.full_name} hasn't confirmed their email yet`}
        description="Their pages stay locked until they do. To open them, return to your account and choose Mark email verified on their user page."
      />
    );
  }

  return <Navigate to={`${paths.verifyEmail}?email=${encodeURIComponent(user.email)}`} replace />;
}
